import React from 'react';
import { MenuItemType } from './RouteMenu/type';
import Icon, { IconClass } from '@/components/Icon';
import { SysPermissionTreeVo } from '@/services/type';
import { match } from 'path-to-regexp';

function getItem(
  label: React.ReactNode,
  key?: React.Key | null,
  icon?: React.ReactNode,
  children?: MenuItemType[],
  type?: 'group',
): MenuItemType {
  return {
    key,
    icon,
    children,
    label,
    type,
  } as MenuItemType;
}

export const menuItems: MenuItemType[] = [
  getItem('订单中心', '/order', <Icon type={IconClass.ORDER_MENU} />, [
    getItem('同城订单', '/order/city'),
    getItem('快递订单', '/order/oms'),
  ]),
  getItem('运单中心', '/waybill', <Icon type={IconClass.WAYBILL_MENU} />, [getItem('运单管理', '/waybill/list')]),
  getItem('报价管理', '/quote', <Icon type={IconClass.QUOTE_MENU} />, [getItem('报价管理', '/quote/list')]),
  getItem('客户中心', '/customer', <Icon type={IconClass.CUSTOMER_MENU} />, [getItem('客户管理', '/customer/list')]),
  getItem('系统管理', '/system', <Icon type={IconClass.SYSTEM_MENU} />, [
    getItem('账号管理', '/system/user'),
    getItem('角色管理', '/system/role'),
  ]),
];

export function findItemByKey(data: SysPermissionTreeVo[], targetKey: string): SysPermissionTreeVo | null {
  let result: SysPermissionTreeVo | null = null;

  function traverse(items: SysPermissionTreeVo[]) {
    for (const item of items) {
      const regexp = match(item.url ?? '');
      if (regexp(targetKey)) {
        result = item;
        return;
      }
      if (item.children) {
        traverse(item.children);
        if (result) return;
      }
    }
  }

  traverse(data);
  return result;
}
